module.exports = __webpack_public_path__ + "static/media/etna.2775e000.png";